const getApiBaseUrl = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "development":
      return "http://localhost:8080";
    case "production":
      return "https://www.api.techcyclehub.com";
    case "test":
      return "https://api.test.techcyclehub.com";
    default:
      return "https://www.api.techcyclehub.com";
  }
};

module.exports = { getApiBaseUrl };
